export const STATUS_LABEL_MAP: Record<string, string> = {
  EXIST: 'Active',
};

export default {};
